import { useState, useEffect, useCallback } from 'react'
import { getUserReferralData, generateReferralLink, shareReferralLink } from '../utils/referralService'
import GameChoiceModal from './GameChoiceModal'
import './ReferralCard.css'

export default function ReferralCard({ user }) {
  const [referralData, setReferralData] = useState(null)
  const [copied, setCopied] = useState(false)
  const [loading, setLoading] = useState(true)
  const [showGameChoice, setShowGameChoice] = useState(false)

  const loadReferralData = useCallback(async () => {
    setLoading(true)
    const data = await getUserReferralData(user.uid)
    setReferralData(data)
    
    // Verifica se tem escolha de jogo pendente
    if (data && data.pendingGameChoice) {
      setShowGameChoice(true)
    }
    
    setLoading(false)
  }, [user])

  useEffect(() => {
    if (user) {
      loadReferralData()
    }
  }, [user, loadReferralData])

  async function handleShare() {
    if (!referralData) return
    
    const result = await shareReferralLink(referralData.referralCode)
    
    if (result === 'copied') {
      setCopied(true)
      setTimeout(() => setCopied(false), 3000)
    }
  }

  function handleGameUnlocked(gameId) {
    console.log('Game unlocked:', gameId)
    // Recarrega os dados após desbloquear
    loadReferralData()
  }

  if (loading) {
    return (
      <div className="referral-card loading">
        <p>Carregando...</p>
      </div>
    )
  }

  if (!referralData) return null

  const referralLink = generateReferralLink(referralData.referralCode)
  const referralCount = referralData.referralCount || 0
  const gamesUnlocked = referralData.gamesUnlockedByReferral || 0
  const nextGameAt = (Math.floor(referralCount / 5) + 1) * 5
  const progress = (referralCount % 5) / 5 * 100

  return (
    <div className="referral-card">
      {showGameChoice && (
        <GameChoiceModal
          user={user}
          onClose={() => setShowGameChoice(false)}
          onGameUnlocked={handleGameUnlocked}
        />
      )}

      <div className="referral-header">
        <h3>🎁 Programa de Indicação</h3>
        <p className="referral-subtitle">Convide amigos e desbloqueie jogos grátis!</p>
      </div>

      <div className="referral-stats">
        <div className="stat-item">
          <div className="stat-value">{referralCount}</div>
          <div className="stat-label">Amigos Convidados</div>
        </div>
        <div className="stat-divider">➜</div>
        <div className="stat-item">
          <div className="stat-value">{gamesUnlocked}</div>
          <div className="stat-label">Jogos Desbloqueados</div>
        </div>
      </div>

      <div className="referral-progress">
        <div className="progress-info">
          <span>Próximo jogo em: <strong>{nextGameAt - referralCount}</strong> indicações</span>
        </div>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>
      </div>

      {referralData.pendingGameChoice && (
        <div className="pending-choice-banner">
          <p>🎉 Você completou 5 indicações!</p>
          <button onClick={() => setShowGameChoice(true)} className="choose-game-btn">
            🎮 Escolher Jogo Agora
          </button>
        </div>
      )}

      <div className="referral-how-it-works">
        <p className="info-title">📋 Como funciona:</p>
        <ul>
          <li>✨ Compartilhe seu link de indicação</li>
          <li>👥 A cada <strong>5 amigos</strong> que se cadastrarem</li>
          <li>🎮 Você <strong>escolhe 1 jogo</strong> para desbloquear gratuitamente!</li>
        </ul>
      </div>

      <div className="referral-code-section">
        <label>Seu código de indicação:</label>
        <div className="code-display">
          <code>{referralData.referralCode}</code>
        </div>
      </div>

      <div className="referral-link-section">
        <label>Seu link de indicação:</label>
        <div className="link-display">
          <input 
            type="text" 
            value={referralLink} 
            readOnly 
            onClick={(e) => e.target.select()}
          />
        </div>
      </div>

      <button 
        className="share-btn" 
        onClick={handleShare}
      >
        {copied ? '✅ Link Copiado!' : '🔗 Compartilhar Link'}
      </button>

      {referralData.referredUsers && referralData.referredUsers.length > 0 && (
        <div className="referral-list">
          <p className="list-title">Seus convidados:</p>
          <div className="invited-count">
            🎉 {referralData.referredUsers.length} {referralData.referredUsers.length === 1 ? 'pessoa' : 'pessoas'}
          </div>
        </div>
      )}
    </div>
  )
}
